import { useTranslation } from 'react-i18next';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CircleIcon from '@mui/icons-material/Circle';
import { colors } from '../../../theme/settings';
import { passwordRules, ruleSeparatorMessage } from '../../utils';

interface ValidationRulesProps {
    watchField: string;
    checkSubRulesPasswordStrength: (password: string) => boolean;
}

const ValidationRules = ({ watchField, checkSubRulesPasswordStrength }: ValidationRulesProps) => {
    const { t } = useTranslation();
    const isSubRulePassed = checkSubRulesPasswordStrength(watchField);
    const isRulePassed = (regex: RegExp | null) => regex?.test(watchField);

    return (
        <Box
            sx={{
                borderRadius: '3px',
                border: `1px solid ${colors.grey2}`,
                padding: '14px 0',
            }}
        >
            <Typography sx={{ fontSize: '14px', marginBottom: '7px', marginLeft: '16px' }}>
                {t('password-must-contain')}
            </Typography>
            <List
                sx={{
                    marginLeft: '10px',
                }}
            >
                {passwordRules.map((rule) => (
                    <ListItem
                        key={rule.message}
                        sx={{
                            padding: 0,
                            marginBottom: '7px',
                            height: '20px',
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                color:
                                    (rule.message === ruleSeparatorMessage && isSubRulePassed) ||
                                    isRulePassed(rule.regex)
                                        ? 'common.system.success.main'
                                        : 'common.system.error.main',
                                minWidth: '20px',
                                marginLeft: rule?.isSubRule ? '25px' : '0',
                            }}
                        >
                            {(rule.message === ruleSeparatorMessage && isSubRulePassed) || isRulePassed(rule.regex) ? (
                                <CheckIcon sx={{ fontSize: '18px', margin: '0 7px 0 4px' }} />
                            ) : (
                                <CircleIcon sx={{ fontSize: '6px', margin: '0 13px 0 10px', color: colors.grey1 }} />
                            )}
                        </ListItemIcon>

                        <ListItemText
                            primary={rule.message}
                            primaryTypographyProps={{
                                sx: { fontSize: '14px' },
                            }}
                            sx={{
                                color:
                                    (rule.message === ruleSeparatorMessage && isSubRulePassed) ||
                                    isRulePassed(rule.regex)
                                        ? 'common.system.success.main'
                                        : 'common.grey1',
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default ValidationRules;
